/**
 *  无证书管理
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React,{ Fragment} from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import ImageHover from "../Components/ImageHover";
import {Spin, Row, Col, Form, Divider, Popconfirm, Input, Checkbox, Space, Button, message,Modal,Empty} from 'antd';
import dayjs from "dayjs";
import {Prompt} from 'react-router-dom';
import Lang from "@components/Lang/Lang";
import {isEmpty} from '@utils/utils';
import  utilExcelStrict from '@utils/utilExcelStrict';
import "./List.less";
import CustomsDeclarationStickerAction from "../CustomsDeclarationSticker.action";
import SearchForm from '@components/SearchForm/SearchForm';

const { TextArea } = Input;
const FormComponent = Form;
const FormItem = FormComponent.Item;
const config = require("@config/config");

class NoCertificateManagement extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isHadEdit: false, //是否编码过
            item:{},
            list: [  ],
            searchFormOptions:[
                {
                    name:'time',
                    cnTitle:'下单时间',
                    cnTitleId:'XiaDanShiJian',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    type:'DateRangePicker'
                },
                {
                    name:'skuNo',
                    cnTitle:'商品编码',
                    cnTitleId:'ShangPinBianMa',
                    cnPlaceholder:'请输入商品编号',
                    cnPlaceholderId:'QingShuRuShangPinBianHao'
                }
            ],
            certDict: [
                { label: Lang({id:'YouZhengShu',default:'有证书'}), value: 1 },
                { label: Lang({id:'WuZhengShu',default:'无证书'}), value: 0 },
                // { label: 'Orange', value: 'Orange', disabled: true },
            ],
            formItemLayout:{
                labelAlign: 'left',
            },
            selectCancelAll:false,
        }
        this.listener = e => {
            if(this.state.isHadEdit){
                e.preventDefault();
                e.returnValue = Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'}) // 浏览器有可能不会提示这个信息，会按照固定信息提示
            }
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    // 格式化 时长
    getDayTime(str='') {
        if(isEmpty(str)) return;
        const value =  str.toString().replace(/[^\d.]/g,"");//Number(str);
        let theTime = parseInt(value/1000);// 秒
        let day= 0;// 天
        let middle= 0;// 分
        let hour= 0;// 小时
        let result = "";
        if(theTime > 60) {
            middle= parseInt(theTime/60);
            if(middle> 60) {
                day = parseInt(middle/60/24);
                hour= parseInt(middle/60)-day*24;
                middle= parseInt(middle%60);
            }
            if(middle > 0) {
                result = middle + Lang({id: 'Fen', default: '分'});
            }
            if(hour> 0) {
                result = hour +Lang({id: 'XiaoShi', default: '小时'})+' '+result;
            }
            if(day>0){
                result = day +Lang({id: 'TianS', default: '天'})+' '+result;
            }
        }else result = 1 + Lang({id: 'Fen', default: '分'});
        return result;
    }
    /**
     * 渲染列表
     * @list 数据源
     * @type 编辑类型 edit 可编辑 view 查看状态，不可编辑
     * @formItemLayout 格式
     * @certDict 证书类型
     * @checkedAll 是否全选
     * **/
    renderList(list=[],type='',formItemLayout,certDict,checkedAll=false){
        let reChild = [];
        list.forEach((item,inx)=>{
            item.disabled = type=='view'?true:false;
            reChild.push(<div className={'itemLi'} key={inx}>
                <div className={'pro'}>
                    <Checkbox checked={item.checked} onChange={(e)=>this.onChangeField(e.target.checked,inx,'checked')} />
                    <ImageHover src={item.skuPictureUrl} />
                </div>
                <div className={'info'}>
                    <div className={'top'}>
                        <div className={'tips'}>{Lang({id: 'DingDanShiJian', default: '订单时间'})}<span>{dayjs(item.poCreateTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                            {item.cancelTime&&<span
                                dangerouslySetInnerHTML={{__html:Lang({id: 'ShangPinJiangYuHouGuXiaoCaiGou', default: '商品将于<b>{0}</b>后取消采购',params:[this.getDayTime(item.cancelTime)]})}}></span>}
                            </div>
                        {/*<div className={'tips'}>{Lang({id: 'PODanHao', default: 'PO单号'})}<span>{item.poCodes}</span></div> */}
                        <p className={'blackLink'}><a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`} target={'_blank'}>{item.skuNameRu}</a></p>
                        <div className={'tips'} style={{'marginTop':'15px'}}>{Lang({id: 'PODanHao', default: 'PO单号'})}
                        <span>{item.poCodes||'-'}</span>
                            <Divider type="vertical" />
                        <span className={'color-black'}>{item.deliveryQuantity||'-'}{Lang({id:'Xiang',default:'箱'})}</span>
                        <Divider type="vertical" />
                         {Lang({id: "HeJi", default: "合计"})}
                         <span className={'color-black'}>{item.priceTotal||'-'}&nbsp; {item.currencySymbol}</span>
                        </div>
                    </div>
                    <div className={'desc'}>
                        <Row gutter={24}>
                            <Col span={6} className={'descItem'}>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{item.skuNo}</span></Col>
                            <Col span={8} className={'descItem'}>{Lang({id: 'LeiMu', default: '类目'})}<span>{item.categoryName}</span></Col>
                            <Col span={8} className={'descItem'}>{Lang({id: 'CaiZhi', default: '材质'})}<span>{item.mainMaterials}</span></Col>
                            {/*<Col span={12} className={'descItem'}>{Lang({id: 'BaoZhuangNianLingBiaoQian', default: '包装年龄标签'})}<span>{item.mark}</span></Col>*/}
                            {/*<Col span={18} className={'desc-item'}>{Lang({id: 'BaoZhuangLeiXing', default: '包装类型'})}<span>{item.packagingType}</span></Col>*/}
                            {this.renderAttribute(item.attributeList)}
                        </Row>
                    </div>
                    <div className={'cerSetBox'}>
                        <div className={'reviewer'}>
                            {Lang({id: 'ShenHeRen', default: '审核人'})}<span>{item.handleName}</span>
                        </div>
                        <div className={'comment'}>
                            {item.remark}
                        </div>
                        <div className={'optionAction'}>
                            <Space>
                                <Popconfirm placement="topLeft" title={Lang({id:'QingQueRenShiFouDuiXuanZeDeShangPinQuXiaoCaiGou',default:'请确认是否对选择的商品取消采购'})}
                                            okText={Lang({id:'queren',default:'确认'})} cancelText={Lang({id:'QuXiao',default:'取消'})}
                                            onConfirm={()=>this.updateCurrSKU(item,0,1)}>
                                    <Button className={item.isCancelGoods==1?'btn on':'btn'}>{Lang({id:'QuXiaoCaiGou',default:'取消采购'})}</Button>

                                </Popconfirm>
                                <Button className={item.hasCertificate==1?'btn on':'btn'} onClick={()=>this.onChangeField(1,inx,'hasCertificate')}>{Lang({id:'ChongXinSheZhiTieZhi',default:'重新设置贴纸'})}</Button>
                            </Space>
                        </div>
                        {item.hasCertificate==1&&<Fragment>
                            {/* <FormItem {...formItemLayout} label={''} rules={[{ required:true, message: ''}]}>
                                <Input value={item.certificateCode} onChange={(e)=>this.onChangeField(e.target.value,inx,'certificateCode')} placeholder={Lang({id: 'certificateEncoding', default: '证书编码'})} />
                            </FormItem> */}
                            <FormItem {...formItemLayout}
                                      label={''}
                                      rules={[{ required:item.required? true:false, message: ''}]}>
                                <TextArea placeholder={Lang({id: 'BeiZhu', default: '备注'})} onChange={(e)=>this.onChangeField(e.target.value,inx,'newRemark')} disabled={item.disabled} />
                            </FormItem>
                            <Button type={'primary'} onClick={()=>this.updateCurrSKU(item,1,0)}>{Lang({id:'QueDing',default:'确定'})}</Button>
                        </Fragment>}
                    </div>
                </div>
            </div>)
         });
        return reChild;
    }

    // 属性列表
    renderAttribute(attributeList=[]){
        let childAtt = [];
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0)childAtt.push(<Col span={inx==0?6:12} key={inx} className={'descItem'}>{att.attributeName}{att.optionList&&att.optionList.map((item, suInx)=>(<span key={suInx}>{item.optionName}</span>))}</Col>)
        })
        return childAtt;
    }
    /**
     * 更新 当前SKU
     * @item 更新项
     *
     * */
    updateCurrSKU(item={},hasCertificate=0,isCancelGoods=0){


        // if(hasCertificate==1){
        //    if(isEmpty(item.certificateCode)){
        //        message.warn(Lang({
        //            id:'QingTianXieZhengShuBianMa',
        //            default:'请填写证书编码'
        //        }))
        //        return
        //    }
        // }

        let postList = []
        postList.push({
            certificateCode:item.certificateCode,
            hasCertificate:hasCertificate,
            isCancelGoods:isCancelGoods,
            remark:item.newRemark,
            skuId:item.skuId,
        })
        const postData = {
            goodsList: postList
        }
        this.loading(true);
        CustomsDeclarationStickerAction.saveNoCertificateGoods(postData).then(res=>this.handleSaveRes(res.data)).catch(err=>this.handleSaveRes(err))
    }
    /**
     * 行编
     *
     * */
    onChangeField(value,inx,field){
        // console.log('行',value,inx,field)
        const {list,isHadEdit,} = this.state;
        let {selectCancelAll,} = this.state;
        let newList = [...list];
        newList[inx][field] = value;

        if(field=='isCancelGoods'&&value==1){
           newList[inx]['hasCertificate'] = 0;
        }else if(field=='hasCertificate'&&value==1){
           newList[inx]['isCancelGoods'] = 0;
            selectCancelAll = false;
        }
        this.setState({
            list:newList,
            selectCancelAll:selectCancelAll
        })
        if(!isHadEdit)this.setHadEdit(true);
    }
    /**
     * 设置是否编辑过
     **/
    setHadEdit(flag){
        this.setState({
            isHadEdit : flag
        })
    }
    /**
     * 提交按钮
     * */
    handleOK = async() => {
        let res =  {}
        try {
            const values = await this.formRef.current.validateFields();
            res= {code:200,data: values};
            // console.log('values',res)
        } catch (errorInfo) {
            res= {code:1006}
        }
        return res
    };
    formRef = React.createRef();
    /**
     * 全选  todo 控制不全选
     * */
    onChangeCheckALL(value){
        const {list} = this.state;
        let newList = [...list];
        newList.forEach(item=>item.checked = value);
        this.setState({
            checkedAll: value,
            list: newList
        })
    }
    /**
     * 批量取消
     * */
    handleCancelItem(){
        const {list,selectCancelAll} = this.state;
        let newList = [...list];
        newList.forEach(item=>{
            if(item.checked){
                item.isCancelGoods=selectCancelAll?0:1;
                item.hasCertificate=0;
            }
        });
        this.setState({
            list: newList,
            selectCancelAll:!selectCancelAll,
        })
    }
    /**
     * 获取列表
     * */
    getList(searchMap={},pageIndex=1,pageSize=50){
        this.loading(true);
        const postData = {
            ...searchMap,
            // pagingQuery: {
            //     pageIndex: pageIndex,
                // pageSize:pageSize,
            // }
        }
        CustomsDeclarationStickerAction.getNoCertificateList(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model,models} = res;
        if(success&&valid){
            this.setState({
                item:model||{},
                list: models||[],
            })
        }
    }

    /**
     *  显示按钮逻辑
     *  0110 从 查找是否有取消采购商品 改为选中 and 找到有一个即可显示按钮
     */
    getCheckNum(list){
        // const iNum = list.findIndex(item=>item.checked==true&&item.isCancelGoods==1)||[];// 	0：不取消 1：取消
        const iNum = list.findIndex(item=>item.checked==true)||[];// 	0：不取消 1：取消
        return iNum
    }
    // onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    // 批量处理保存
    handleBatchSave(){
        const {list} = this.state;
        let postList = [];
        list.forEach(item=>{
           if(item.checked) postList.push({ // 0：不取消 1：取消 &&item.isCancelGoods==1
                certificateCode:item.certificateCode,
                hasCertificate:item.hasCertificate,
                isCancelGoods:item.isCancelGoods,
                remark:item.remark,
                skuId:item.skuId,
            })
        })
        if(postList.length>0){
            const postData = {
                goodsList: postList
            }
            this.loading(true);
            CustomsDeclarationStickerAction.saveNoCertificateGoods(postData).then(res=>{
                    // console.log('res',res)
                    this.handleSaveRes(res.data)
                }
            ).catch(err=>this.handleSaveRes(err))
        }
    }
    handleSaveRes(res){
        this.loading(false);
        const {success,valid,model,models} = res;
        if(success&&valid){
            message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}));
            this.getList();
            this.setHadEdit(false);
        }else if(res.message){
            message.warning(res.message);
        }else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    /**
     * 下载按钮
     * */
    handleDownExcel(list) {
        const needDownList = list.filter(item=>item.checked==true)||[];
        if(needDownList&&needDownList.length>0){
            this.loading(true);
            const columns = [
                {
                    header: Lang({id: 'ShangPin', default: '商品'}),
                    key: 'skuPictureUrlno',
                    width: 30,
                },
                {
                    header: Lang({id: 'ShangPinMingChen', default: '商品名称'}),
                    key: 'skuNameRu',
                    width: 30,
                },
                {
                    header: Lang({id: 'ShangPinBianMa', default: '商品编码'}),
                    key: 'skuNo',
                    width: 15,
                },
                {
                    header: Lang({id: 'BaoZhuangNianLingBiaoQian', default: '包装年龄标签'}),
                    key: 'mark',
                    width: 20,
                },
                {
                    header: Lang({id: 'CaiZhi', default: '材质'}),
                    key: 'mainMaterials',
                    width: 20,
                },
                {
                    header: Lang({id: 'LeiMu', default: '类目'}),
                    key: 'categoryName',
                    width: 20,
                },
                {
                    header: Lang({id: 'BaoZhuangLeiXing', default: '包装类型'}),
                    key: 'packagingType',
                    width: 15,
                },
                {
                    header: Lang({id: 'YouZhengShu', default: '有证书'}),
                    key: 'hasCertificate',
                    width: 15,
                },
                {
                    header: Lang({id:'QuXiaoCaiGou',default:'取消采购'}),
                    key: 'isCancelGoods',
                    width: 15,
                },
                {
                    header: Lang({id: 'ShenHeRen', default: '审核人'}),
                    key: 'handleName',
                    width: 15,
                },
                {
                    header: Lang({id: 'BeiZhu', default: '备注'}),
                    key: 'remark',
                    width: 15,
                }
            ]
            const downList = this.handleDownList(needDownList);
            utilExcelStrict.exportFile(columns, downList, Lang({id: "WuZhengShuShangPin",default: "无证书商品"}), res => {
                setTimeout(() => this.loading(false), 400)
            })
        }else Modal.info({
            title: Lang({id: 'QingXuanZeShangPinHouZaiXiaZai', default: '请选择商品后再下载'}),
            onOk() {},
        });
    }
    /**
     * 处理下载数据 TODO 优化合并在渲染页面时
     * */
    handleDownList(list = []){
        let downList = [];
        list.forEach(item=>{
            const attributeList = item.attributeList||[];
            let packagingType = ''; // 包装类型
            let sMark = ''; // 包装年龄标签
            attributeList.forEach(att=>{
                if(att.attributeCode == 'PKG'){
                    let str = ""
                    if(att.optionList&&att.optionList.length>0)att.optionList.map(item=>str += item.optionName+"");
                    packagingType = str;
                }
                if(att.attributeCode == 'bznlb'){
                    let str = ""
                    if(att.optionList&&att.optionList.length>0)att.optionList.map(item=>str += item.optionName+"");
                    sMark = str
                }
            })
            let downItem = {...item}

            //  有证书 1 , '无证书' : 0
            downItem['hasCertificate'] = item.hasCertificate==1?Lang({id:'YouZhengShu',default:'有证书'}): Lang({id:'WuZhengShu',default:'无证书'});
            downItem['isCancelGoods'] = item.isCancelGoods==1?Lang({id:'Shi',default:'是'}): Lang({id:'Fou',default:'否"'});
            downItem['thumbnail'] = item.skuPictureUrl;
            downItem['packagingType'] = packagingType;
            downItem['mark'] = sMark;
            downList.push(downItem)
        })
        return downList;
    }
    /**
     * 獲取表單
     * */
    getFormData(data){
        if(data.time){
            if(data.time[0])data['poBeginCreateTime'] = dayjs(data.time[0]).format('YYYY-MM-DD');
            if(data.time[1])data['poEndCreateTime'] = dayjs(data.time[1]).format('YYYY-MM-DD');
            delete data['time'];
        }
        this.getList(data);
    }
    componentWillUnmount(){
        window.removeEventListener('beforeunload', this.listener)
    }
    componentDidMount() {
        window.addEventListener('beforeunload', this.listener)
        this.getList();
    }
    render(){
        const { loading,checkedAll,list,isHadEdit,formItemLayout,certDict,searchFormOptions } = this.state;
        const currPageName = Lang({id: "WuZhengShuShangPin",default: "无证书商品"});
        const type = 'edit';
        return (<Spin tip='loading' spinning={loading}>
            <Prompt
                when={isHadEdit}
                message={() =>Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'})}
            />
            <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
            <div className="noCertificateListStyle">
                <div className={'content'}>
                    <div className={'title fw_700 font_18'}>{currPageName}</div>
                   <SearchForm
                        options = {searchFormOptions}
                        flagShowReset={false}
                        getSearchValue={(dat)=>this.getFormData(dat)} />

                    {list&&list.length>0?<div className={'itemList'}>
                        <Form ref={this.formRef} onFinish={this.handleOK} name="basic" colon={false} >
                            {this.renderList(list,type,formItemLayout,certDict,checkedAll)}
                            {/*<AutoFetchList onRef={this.onRefAutoFetchList}*/}
                                           {/*fetchApi={'/service/mg/sticker/track/goods-no-certificate-list'}*/}
                                           {/*renderList={this.renderItem.bind(this)}*/}
                            {/*/>*/}
                        </Form>
                    </div>:<div className="emptyWrap">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={Lang({id: "ZanWuShuJu",default: "暂无数据"})} />
                    </div>}
                </div>
                {list&&list.length>0&&<div className={'footer'}>
                    <div className={'left'}>
                        <Checkbox checked={checkedAll} onChange={(e)=>this.onChangeCheckALL(e.target.checked)}>{Lang({id:'QuanXuan',default:'全选'})}</Checkbox>
                        {/*<span className={'btn'} onClick={()=>this.handleCancelItem()}>{Lang({id:'QuXiaoCaiGou',default:'取消采购'})}</span>*/}

                        {this.getCheckNum(list)>-1?<Popconfirm placement="topLeft" title={Lang({id:'QingQueRenShiFouDuiXuanZeDeShangPinQuXiaoCaiGou',default:'请确认是否对选择的商品取消采购'})}
                                                               okText={Lang({id:'queren',default:'确认'})} cancelText={Lang({id:'QuXiao',default:'取消'})}
                                                               onConfirm={()=>this.handleBatchSave()}>
                                <span className={'btn'}>{Lang({id:'QuXiaoCaiGou',default:'取消采购'})}</span>
                            </Popconfirm>:<span className={'btn disable'}>{Lang({id:'QuXiaoCaiGou',default:'取消采购'})}</span>}


                        <span className={'btn'} onClick={()=>this.handleDownExcel(list)}>{Lang({id:'XiaZai',default:'下载'})}</span>
                    </div>
                    {/*<div className={'right'}>*/}
                        {/*{this.getCheckNum(list)>-1?<Popconfirm placement="topLeft" title={Lang({id:'QingQueRenShiFouDuiXuanZeDeShangPinQuXiaoCaiGou',default:'请确认是否对选择的商品取消采购'})}*/}
                                    {/*okText={Lang({id:'queren',default:'确认'})} cancelText={Lang({id:'QuXiao',default:'取消'})}*/}
                                    {/*onConfirm={()=>this.handleBatchSave()}>*/}
                            {/*<span className={'btn'}>{Lang({id:'BaoCun',default:'保存'})}</span>*/}
                        {/*</Popconfirm>:*/}
                        {/*<span className={'btn disable'}>{Lang({id:'BaoCun',default:'保存'})}</span>}*/}
                    {/*</div>*/}
                </div>}
            </div>
        </Spin>)
    }
}
export default NoCertificateManagement;